import { useTranslation } from 'react-i18next';
import { popularCategories } from '@/mocks/categories';

const popImages = [
  {
    url: 'https://readdy.ai/api/search-image?query=High%20end%20designer%20sneakers%20artistic%20arrangement%20on%20light%20warm%20gray%20surface%20with%20diffused%20window%20light%2C%20editorial%20fashion%20catalog%20photography%2C%20soft%20neutral%20shadows%2C%20premium%20textile%20textures%20visible%2C%20contemporary%20minimalist%20composition%20with%20negative%20space&width=400&height=200&seq=hero-pop-v2-01&orientation=landscape',
    className: 'col-span-2 aspect-[2/1]',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Luxurious%20cashmere%20sweater%20draped%20elegantly%20on%20warm%20taupe%20background%2C%20soft%20golden%20hour%20side%20lighting%2C%20visible%20knit%20texture%20detail%2C%20high%20fashion%20editorial%20style%2C%20warm%20cozy%20atmosphere%2C%20premium%20catalog%20shot%20with%20organic%20folds%20and%20shadows&width=400&height=400&seq=hero-pop-v2-02&orientation=squarish',
    className: 'aspect-square',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20jewelry%20and%20leather%20watch%20on%20light%20warm%20stone%20surface%2C%20subtle%20reflections%2C%20soft%20daylight%20through%20sheer%20curtain%2C%20refined%20luxury%20aesthetic%2C%20clean%20editorial%20product%20photography%2C%20warm%20natural%20tones%20with%20gentle%20highlights&width=400&height=400&seq=hero-pop-v2-03&orientation=squarish',
    className: 'aspect-square',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Designer%20tote%20bag%20and%20backpack%20on%20warm%20off%20white%20pedestal%2C%20soft%20directional%20lighting%20from%20left%2C%20premium%20leather%20texture%20detail%2C%20modern%20luxury%20catalog%20photography%2C%20minimalist%20composition%20with%20subtle%20warm%20gray%20backdrop&width=400&height=400&seq=hero-pop-v2-04&orientation=squarish',
    className: 'aspect-square',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Trendy%20oversized%20bomber%20jacket%20styled%20on%20invisible%20mannequin%20against%20warm%20light%20gray%20wall%2C%20soft%20studio%20lighting%2C%20textile%20texture%20emphasis%2C%20contemporary%20streetwear%20editorial%20photography%2C%20clean%20urban%20aesthetic%20with%20gentle%20warm%20tones&width=400&height=400&seq=hero-pop-v2-05&orientation=squarish',
    className: 'aspect-square',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Stylish%20premium%20sports%20jersey%20displayed%20flat%20on%20warm%20beige%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20visible%20fabric%20texture%20and%20stitching%2C%20clean%20modern%20athletic%20apparel%20photography%2C%20warm%20energetic%20aesthetic%20with%20gentle%20shadows&width=400&height=400&seq=hero-pop-v2-06&orientation=squarish',
    className: 'aspect-square',
  },
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center bg-background-50 pt-16 md:pt-20">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-14">
          <div className="w-full lg:w-[35%] flex flex-col justify-center">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-[1.1] tracking-tight">
              {t('hero.title')}
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              {t('hero.subtitle')}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('hero.cta_primary')}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-950 text-foreground-950 text-sm font-semibold rounded-full hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('hero.cta_secondary')}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[35%]">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[3/4] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20editorial%20flat%20lay%20with%20premium%20sneakers%20designer%20hoodie%20and%20accessories%20on%20warm%20light%20gray%20marble%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20large%20window%2C%20visible%20textile%20textures%20leather%20details%2C%20high%20end%20boutique%20catalog%20style%2C%20sophisticated%20warm%20neutral%20palette%20with%20organic%20relaxed%20composition&width=600&height=800&seq=hero-main-v2-01&orientation=portrait"
                alt="Yoybuy Spreadsheet fashion items"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-[30%] flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-5">
              <h3 className="text-lg font-semibold text-foreground-950">{t('hero.popular')}</h3>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-foreground-600"></i>
              </span>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {popularCategories.slice(0, 3).map((cat, idx) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className={`rounded-xl overflow-hidden bg-background-100 relative group cursor-pointer ${popImages[idx].className}`}
                >
                  <img
                    src={popImages[idx].url}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-3 left-3">
                    <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800 rounded-full">
                      {cat.nameRu}
                    </span>
                  </div>
                </a>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-3 mt-3">
              {popularCategories.slice(3).map((cat, idx) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="aspect-square rounded-xl overflow-hidden bg-background-100 relative group cursor-pointer"
                >
                  <img
                    src={popImages[idx + 3].url}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-3 left-3">
                    <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800 rounded-full">
                      {cat.nameRu}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}